import { Signup } from "@/views/auth/signup/account";
import { Signin } from "@/views/auth/signin";
import { ForgotPassword } from "@/views/auth/signin/forgotpassword";
import { ResetPassword } from "@/views/auth/signin/resetpassword";
import { VerifyEmail } from "@/views/auth/signup/verifyEmail";
import { ReviewApplication } from "@/views/auth/signup/reviewApplication";
import { InvitationAccepted } from "@/views/auth/signup/invitationAccepted";

interface AuthRoute {
  path: string;
  view: React.ComponentType;
  layout: string;
  title: string;
}

const Routes: AuthRoute[] = [
  {
    path: "/signup",
    view: Signup,
    layout: "auth",
    title: "Sign Up",
  },
  {
    path: "/signup/verify-email",
    view: VerifyEmail,
    layout: "auth",
    title: "Sign Up",
  },
  {
    path: "/signup/application-review",
    view: ReviewApplication,
    layout: "auth",
    title: "Sign Up",
  },
  {
    path: "/signup/invitation-accepted/:email",
    view: InvitationAccepted,
    layout: "auth",
    title: "Sign Up",
  },
  {
    path: "/signin",
    view: Signin,
    layout: "auth",
    title: "Sign In",
  },
  {
    path: "/forgot-password",
    view: ForgotPassword,
    layout: "auth",
    title: "Forgot Password",
  },
  {
    path: "/resetpassword",
    view: ResetPassword,
    layout: "auth",
    title: "Reset Password",
  },
];

export default Routes;
